<template>
  <InvoiceTransmissionHeader>
    <IncomingInvoiceTransmissionTable/>
  </InvoiceTransmissionHeader>
</template>

<script>

import IncomingInvoiceTransmissionTable from "@/invoice-transmission/components/tables/IncomingInvoiceTransmissionTable.vue";
import InvoiceTransmissionHeader from "@/invoice-transmission/components/InvoiceTransmissionHeader.vue";

export default {
  name: 'FactureXIncomingInvoiceView',
  components: {IncomingInvoiceTransmissionTable, InvoiceTransmissionHeader}
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY

  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
